import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/login")) {
    window.sessionStorage.removeItem("loginuser");
    next();
  } else {
    //let accessToken = JSON.parse(window.localStorage.getItem('accessToken'))
    let loginuser = window.sessionStorage.getItem("loginuser");
    if (loginuser) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  }
});

export default router
